import actionTypes from 'SRC/modules/redux/actionTypes'

export const setTempLogo = (logo) => ({
  type: actionTypes.SET_REGISTRATION_TEMP_LOGO,
  payload: logo
})
